import React, { useState } from "react";
import { StyledTabsContainer } from "./styles";
import UserProfile from "../userProfile/user-profile";
import { UserPassword } from "../userPassword";
import { AppHeader, TabsLayout } from "@root/components";
import { CommonFooter } from "@root/components/auth/commonFooter";
import { StyledDashboardLayoutChildContainer } from "@root/components/common/style";
import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const UserSettingProfile = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation('common')
  const tabs = [t('translate.myProfile'), t('translate.password'), t('translate.managePreferences')];

  const handleTabsChange = (index: any) => {
    setTabIndex(index);
  };

  return (
    <StyledDashboardLayoutChildContainer  >
      <Flex
        justifyContent={'space-between'}
        flexDir={'column'}
        height={'100%'}
      >
        <AppHeader minH={'84px'} title={"Setting"} />
        <StyledTabsContainer>
          <TabsLayout
            tabs={tabs}
            tabIndex={tabIndex}
            onTabChange={handleTabsChange}
          >
            {<UserProfile />}
            {<UserPassword />}
          </TabsLayout>
        </StyledTabsContainer>
        <CommonFooter />
      </Flex>
    </StyledDashboardLayoutChildContainer>
  );
};

export default UserSettingProfile;
